import {
  Home, Building2, Warehouse, DoorOpen, PawPrint, Sofa, TrainFront, CalendarClock,
} from "lucide-react";

// Shared browse categories — used by the landing grid chips and the /map deck.
// The "short" chip also flips the stay type in LocationContext (handled by the
// pages that render these chips).
export const CATEGORIES = [
  { key: "all", label: "All homes", icon: Home, test: () => true },
  { key: "short", label: "Short stay", icon: CalendarClock, test: (l) => l.stay_type === "short" },
  { key: "condos", label: "Condos", icon: Building2, test: (l) => (l.amenities || []).some((a) => /concierge|gym|pool/i.test(a)) },
  { key: "lofts", label: "Lofts", icon: Warehouse, test: (l) => /loft|studio/i.test(l.title) },
  { key: "basements", label: "Basements", icon: DoorOpen, test: (l) => /garden|basement/i.test(`${l.title} ${l.description}`) },
  { key: "pets", label: "Pet friendly", icon: PawPrint, test: (l) => !!l.pets },
  { key: "furnished", label: "Furnished", icon: Sofa, test: (l) => !!l.furnished },
  { key: "transit", label: "Near transit", icon: TrainFront, test: (l) => l.distance_km != null && l.distance_km <= 2 },
];
